import React from 'react';
import logo from './SatanWasALadyUnderConstruction.gif';

function LogoLady(props) {
    return <img {...props} src={logo} alt="Logo"/>;
}

export default LogoLady;
